import axios from "axios";
import { store } from "../store/store";
import { logout, setUser } from "../store/authSlice";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

const plainAxios = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});
let isRefreshing = false;
let failedQueue = [];

const processQueue=(error,token=null)=>{
  failedQueue.forEach((prom)=>{
    if(error){
      console.log("rej1");
      
      prom.reject(error);
    }else{
      prom.resolve(token);
    }
  });
  failedQueue=[];
}

api.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    const originalRequest = err.config;
    const status = err?.response?.status;

  
    if (status === 401 && !originalRequest._retry ) {

      if(isRefreshing){
        return new Promise(function(resolve,reject){
          failedQueue.push({
            resolve : (token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(api(originalRequest));
            },
            reject : (error) => {
              reject(error);
            }
          });
        });
      }
      
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        
        const refreshRes = await plainAxios.post("/api/auth/refresh-token");
        const data = refreshRes?.data?.user;
        const user = {
          ...data,
        };

        store.dispatch(setUser({ user, accessToken: data.token }));
        processQueue(null,data.token );
        originalRequest.headers.Authorization = `Bearer ${data.token}`;
        return api(originalRequest);
      } catch (error) {
        processQueue(error, null);
        store.dispatch(logout());
        sessionStorage.removeItem('header');
        window.location.href = "/login";
        return Promise.reject(error);
      }finally{
        isRefreshing = false;
      }
    }
    return Promise.reject(err);
  }
);
export default api;
